export enum NavigationTabs {
  HOME,
  ACTORS,
  PROJECTS,
  RESOURCES,
  SERVICES,
}
